<template>
  <div class="activity-warp">
    <div class="activity-head">
      <img class="backicon" src="../../assets/imgs/close.png" @click="onBack">
      <div class="activity-title">{{i18nProduct.title}}</div>
    </div>
<!--    <div class="device-select" style="display: flex;font-family: MyFont7">-->
<!--      <label>{{mifisn}}</label>-->
<!--      <div style="text-align: right;width: 100%;" >-->
<!--        <label style="background: #BDBDBD;border-radius: 22px;padding: 5px 10px;color: white;font-size: 10pt;font-family: MyFont8">{{cardOneRealStatus}}</label>-->
<!--      </div>-->
<!--    </div>-->
    <div style="padding: 10px;font-size: 13pt;font-family: MyFont6">
      <label>请选择充值金额</label>
    </div>
    <div style="padding: 10px;">
      <section class="content">
        <div class="item" v-for="(item,index) in productList" :style="item.active == 1 ? 'border: 1px solid #1EBE86':'border: 1px solid #ffffff'" :key="index" @click="pkgItemClick(item)">
          <div style="text-align: center;height: 56px">
            <div>
              <label style="color: #1EBE86;font-size: 16pt;font-family: MyFont7">{{parseFloat(item.rechargeAmount).toFixed(2)}}元</label>
            </div>
            <div>
              <label style="color: red;font-size: 10pt;font-family: MyFont7">{{item.tags}}</label>
            </div>
          </div>
          <div style="margin: 18px -2px 0 0;text-align: right" v-if="item.active == 1">
            <van-image :src="require('assets/imgs/mifi14.png')" width="40px" height="30px"></van-image>
          </div>
        </div>
      </section>
    </div>
    <div style="bottom: 30px;position: absolute;width: 100%;text-align: center">
      <van-button @click="toPay" :disabled="pkgItem.id? false:true" style="color: white;background: #1EBE86;
      width: 70%;border-radius: 50px;font-family: MyFont7">立即充值</van-button>
      <div style="display: inline-flex;width: 70%;margin-top: 20px;">
        <div style="width: 50%;text-align: left;display: flex">
          <van-image class="backgroud-img" :src="require('assets/imgs/mifi07.png')" width="30px" height="30px"></van-image>
          <div style="color: #1EBE86;margin: 5px 0 0 5px;font-family: MyFont8">关注公众号</div>
        </div>
        <div style="width: 50%;">
          <div style="display: flex;justify-content: right">
            <van-image :src="require('assets/imgs/mifi10.png')" width="22px" height="22px" style="margin-top: 3px"></van-image>
            <div style="color: #1EBE86;margin: 5px 0 0 5px;font-family: MyFont8" @click="backHome()">返回首页</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseURL } from '../../utils/http'
import { MIFI_DEVICE_INFO, MIFI_PRODUCT_RCHARGE, MIFI_PRODUCT_RCHARGE_BUY } from '@/apis/cabinet'
import { mapState } from "vuex";
import wxpay from "weixin-jsapi"
export default {
  components: {
  },
  computed: {
    ...mapState(['mifisn']),
    i18nProduct () {
      return this.$t('product')
    }
  },
  watch: {

  },
  data () {
    return {
      productList: [],
      active: 0,
      buyShow: false,
      pkgLab: '',
      pkgItem: {},
      cardOneRealStatus: '未实名'
    }
  },
  methods: {
    productRechargeList() {
      this.$post(
        MIFI_PRODUCT_RCHARGE, {
        }, (resp) => {
          this.$loading(false)
          this.productList = resp.data;
          for (var i = 0; i < this.productList.length; i++) {
            this.productList[i].active = 0
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    pkgItemClick(item) {
      var p = this.productList;
      for (var i = 0; i < p.length; i++) {
        p[i].active = 0
        if (item.id === p[i].id) {
          p[i].active = 1
        }
      }
      this.productList = []
      this.productList = p
      this.pkgItem = item
    },
    toPay() {
      var $this = this
      this.$loading(true)
      this.$post(
        MIFI_PRODUCT_RCHARGE_BUY, {
          id: this.pkgItem.id
        }, (resp) => {
          this.$loading(false)
          /* eslint-disable */
          WeixinJSBridge.invoke('getBrandWCPayRequest', {
              "appId": resp.data.appId,
              "timeStamp": resp.data.timeStamp,
              "nonceStr": resp.data.nonceStr,
              "package": resp.data.packageValue,
              "signType": 'MD5',
              "paySign": resp.data.paySign
            },
            function (res) {
              if (res.err_msg === "get_brand_wcpay_request:ok") {
                $this.$toast("充值成功")
                $this.$router.push('/')
              } else if (res.err_msg === "get_brand_wcpay_request:fail") {
                $this.$toast("失败")
              }
            });
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
        /* eslint-disable */
      )
    },
    deviceInfoById(devId) {
      this.$post(
        MIFI_DEVICE_INFO, {
          devId: devId
        }, (resp) => {
          if (resp.data) {
            if (resp.data.data.online === 0) {
              this.cardOneRealStatus = '离线'
            } else if (resp.data.data.online === 1) {
              this.cardOneRealStatus = '在线'
            } else if (resp.data.data.online === 3) {
              this.cardOneRealStatus = '已拿卡'
            } else if (resp.data.data.online === 4) {
              this.cardOneRealStatus = '拿卡失败'
            } else if (resp.data.data.online === 5) {
              this.cardOneRealStatus = '正在拨号'
            } else if (resp.data.data.online === 6) {
              this.cardOneRealStatus = '下线'
            } else if (resp.data.data.online === 6) {
              this.cardOneRealStatus = '本地卡在线'
            }
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onBack () {
      this.$router.go(-1)
    },
    backHome() {
      this.$router.push('/')
    }
  },
  created () {
    this.productRechargeList()
  //  this.deviceInfoById(this.mifisn)
  }
}
</script>

<style lang="less" scoped>
.activity-warp {
  height: 100vh;
  // background: linear-gradient(#00AB46, #1A2229);
  background: #F4F4F4;
  .activity-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

    .backicon {
      width: 50px;
    }
    .activity-title {
      text-align: center;
      width: 100%;
      font-family: Montserrat, Montserrat;
      font-weight: bold;
      font-size: 36px;
      color: #1A2229;
    }
  }
}
.content {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.item {
  /*  1. 其中 10 为间隙的中和  */
  width: 46%;
  height: 200px;
  margin: 10px;
  background: white;
  border-radius: .3rem;
  padding-top: 12px;
}
.device-select{
  text-align: left;
  border-left: 5px solid #1EBE86;
  margin-left: 20px;
  margin: 20px;
  label{
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    margin-left: 15px;
  }
}
</style>
